import React from "react";
import moment from "moment";

const TabChecking = ({ open, loading, tabletCollected, tabletCollectedAt, onMarkCollected, onClose }) => {
  if (!open) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className={`modal-status ${tabletCollected ? 'success' : ''}`}>
         
          {tabletCollected ? (
            <div style={{ textAlign: 'center', padding: '20px' }}>
              <p style={{ fontSize: '18px', marginBottom: '10px' }}>
                ✓ Tablet Already Collected
              </p>
              <p style={{ fontSize: '14px', color: '#666', marginBottom: '20px' }}>
                Collected on: {moment(tabletCollectedAt).format('MMMM DD, YYYY [at] hh:mm A')}
              </p>
              <button 
                className="id-generator__actions-register-big" 
                onClick={onClose}
                style={{ marginTop: '10px' }}
              >
                Close
              </button>
            </div>
          ) : (
            <div style={{ textAlign: 'center', padding: '20px' }}>
              <p style={{ fontSize: '18px', marginBottom: '20px' }}>
                Mark tablet as collected
              </p>
              <button 
                className="id-generator__actions-register-big" 
                onClick={onMarkCollected} 
                disabled={loading}
              >
                {loading ? "Loading..." : "Mark as Collected"}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TabChecking;
